import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../Components";
import Header from "../commonComponent/Header";
import { unsubscribe } from "../API/apiRequest";
import { Context } from "../../context/Context";
import Loader from "../commonComponent/Loader";

function Unsubscribe() {
  const msisdn = localStorage.getItem("msisdn");
  const navigate = useNavigate();
  const { handleShowModal } = useContext(Context);
  const [isLoader, setIsLoader] = useState(false);

  const handleButton = () => {
    setIsLoader(true)
    unsubscribe(msisdn)
      .then((resp) => {
        setIsLoader(false)
        console.log("unsub api resp::", resp);
        if (resp?.messageCode == "00") {
          navigate(`/otp?type=unsub`);
        } else if (resp?.messageCode == "12") {
          const modalData = {
            title: "Error",
            body: 'تم إلغاء الاشتراك بالفعل.',
            messageCode: resp?.messageCode,
            buttons: [
              {
                label: "حسنًا",
                action: "close",
              },
            ],
            handleClick: function (value) {
              if (value === "close") {
                handleShowModal(false);
              }
              console.log("button clicked");
            },
          };
          handleShowModal(true, modalData);
        } else {
          navigate("/sub-status?type=technical_error");
        }
      })
      .catch((err) => {
        setIsLoader(false)
        console.log("err in unsub api ::", err);
      });
  };

  return (
    <>
      {isLoader && <Loader />}
      <div className="bg-darkPurple flex flex-col h-screen">
        <Header />
        <div className="flex-grow mt-36">
          <div className="mt-2 bg-lightPurple flex text-center m-4 rounded-xl p-4 flex-col items-center text-white">
            <div className="w-full ">
              <div className="flex justify-between font-semibold w-full text-xl">
                <div>Subscription Status:</div>
                <div className="bg-lightGreen px-2 rounded-md">Active</div>
              </div>
              <div className="text-left mt-2 text-buttonYellow">
                Next Renewal: 4th March 2024
              </div>
            </div>
            <Button
              name="Unsubscribe Now"
              handleClick={handleButton}
              className="h-12 bg-buttonYellow mt-8 rounded-full font-bold  text-darkPurple text-xl w-80"
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Unsubscribe;
